module.exports = __webpack_public_path__ + "img/vsdigibarcode.578d603f.jpeg";